import { Component, input } from '@angular/core';
import {
    ContentRelationshipField,
    ImageField,
    KeyTextField,
    NumberField,
    RichTextField,
    SelectField,
    Slice,
    TitleField
} from '@prismicio/client';
import { Member } from '../team-slice/team-slice.component';
import { RenderHtmlPipe } from '../render-html/render-html.pipe';
import { HTMLMapSerializer } from '@prismicio/helpers';
import { AosDirective } from '../../aos/aos.directive';
import { LinkComponent } from '../../link/link.component';

@Component({
    selector: 'app-text-and-benefits-slice',
    standalone: true,
    imports: [RenderHtmlPipe, AosDirective, LinkComponent],
    templateUrl: './text-and-benefits-slice.component.html',
    styleUrl: './text-and-benefits-slice.component.scss'
})
export class TextAndBenefitsSliceComponent {
    body = input.required<TextAndBenefitsSlice>();

    headingSerializer: HTMLMapSerializer = {
        heading2: ({ children }) => '<h2 class="heading">' + children + '</h2>',
        paragraph: ({ children }) => '<p class="heading">' + children + '</p>'
    };

    htmlSerializer: HTMLMapSerializer = {
        heading2: ({ children }) => '<h2 class="text-size-l">' + children + '</h2>',
        paragraph: ({ children }) => '<p class="text-size-l">' + children + '</p>'
    };

    benefitSerializer: HTMLMapSerializer = {
        heading3: ({ children }) => '<h3 class="text-size-m">' + children + '</h3>',
        paragraph: ({ children }) => '<p class="text-size-m">' + children + '</p>'
    };
}

export type TextAndBenefitsSlice = Slice<
    'text_and_benefits',
    {
        heading: RichTextField;
        slice_title: RichTextField;
        slice_description: RichTextField;
        button_title: KeyTextField;
        button_link: ContentRelationshipField;
        button_action: SelectField;
    },
    {
        benefit_title: RichTextField;
        benefit_description: RichTextField;
        icon: ImageField;
    }
>;
